<template>
  <section class="ticket-group">
    <ul class="voucher-list">
      <template v-for="(products) in groupInfo.products">
        <li v-for="(voucher, index) in products.concurrency">
          <div class="inner-wrap">
            <div class="label-area">
              <h3>
                <span>{{ getValue(voucher, 'product_name') }}</span>
                <span v-if="isInUse(voucher)" class="icon">이용중</span>
                <span v-if="isRecommendation(voucher)" class="icon icon-supplant">추천</span>
              </h3>
              <!-- D: 제휴 탭 및 개별구매 및 패키지 시 -->
              <div v-if="productType !== 'voucher' && (productType !== 'google' && productType !== 'onestore')" class="price-area">
                <button type="button" @click="voucherPurchase(voucher, getValue(voucher, 'productid'),productType)"
                        :class="getValue(voucher, 'productid') === getValue(selectedVoucher, 'productid') ? 'btn selected' : 'btn'">
                  <span>{{productType !== 'voucher' ? `${getValue(voucher, 'use_day')} / ` : ''}}</span>
                  <span class="won">&#65510;{{ setNumberCommas(getValue(voucher, 'amount')) }}</span>
                </button>
              </div>
            </div>
            <voucher-table-list v-if="productType !== 'one' && productType !== 'package'"
                                :support-device="getValue(voucher, 'support_device')"
                                :quality="qualityText(getValue(voucher, 'quality'))"
                                :concurrency="getValue(voucher, 'concurrency_count') + '명'"/>
            <div class="button-area" v-if="productType !== 'one' && productType !== 'package'">
              <button v-for="(amountData, index) in purchaseAmountInfoList(voucher)"
                      @click="voucherPurchase(voucher, getAmountDataValue(amountData, 'productid'), productType)"
                      :class="getAmountDataValue(amountData, 'productid') === getValue(selectedVoucher, 'productid') ? 'btn selected' : 'btn'"
                      type="button" :key="'amount_button_' + index">
                  <span class="month">
                    <span>{{ getAmountDataValue(amountData, 'use_day') }}</span>
                    <span class="discount" v-if="isDiscount(amountData)">{{ getAmountDataValue(amountData, 'discount_rate') }}%</span>
                  </span>
                <span class="price">
                    <span>&#65510;{{ setNumberCommas(getAmountDataValue(amountData, 'amount')) }}</span>
                    <span class="summary" v-if="isMonthAmount(amountData)">(월 &#65510;{{ setNumberCommas(getAmountDataValue(amountData, 'month_amount')) }})</span>
                  </span>
              </button>
            </div>
          </div>
          <div v-if="productType === 'package'" class="product-package">
            <ul>
              <li v-for="(packageItem, index) in packageList" :key="'package_detail_' + index">
                <div class="picture-area">
                  <WebpImage :image-info="{imageUrl: getValue(packageItem, 'image'), width: 104, height: 156, alt: getValue(packageItem, 'title')}" />
                </div>
                <span class="product-package-title">
                  <span>{{getValue(packageItem, 'title')}}</span>
                </span>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </ul>
  </section>
</template>

<script>
import { filter, get, defaultTo } from 'lodash'
import { resizeThumbnail } from '@/common/image.filter'
import utils from '@/common/util/utils'
import { PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE } from '@/common/constant'
import VoucherTableList from '@/components/lnb/voucher/VoucherTableList'
import WebpImage from '@/components/image/WebpImage'
export default {
  name: 'AllProductGroups',
  components: { WebpImage, VoucherTableList },
  props: {
    groupInfo: {
      type: Object
    },
    productType: {
      type: String
    },
    packageDetailList: {
      type: Array
    },
    purchaseFn: {
      type: Function
    },
    categoryIndex: {
      type: Number
    }
  },
  data () {
    return {
      tooltipToggle: false,
      selectedVoucher: ''
    }
  },
  computed: {
    packageList () {
      const productId = get(this.groupInfo, 'products.0.concurrency.0.productid', '')
      return get(filter(this.packageDetailList, (item) => item.productId === productId), '0.list', [])
    },
    amount () {
      return (this.productType === 'one' || this.productType === 'package') && utils.getPgName() === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE ? '코인' : '원'
    }
  },
  methods: {
    setNumberCommas (data) {
      if (!data) return 0
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    resizeImage (url) {
      return resizeThumbnail(url, { width: 104, height: 156 })
    },
    getValue (item, key) {
      return get(item, [key], '')
    },
    qualityText (text) {
      return text.toUpperCase() === 'UHD' ? '최고 화질' : text + ' 화질'
    },
    voucherPurchase (voucher, productId, productType) {
      this.selectedVoucher = Object.assign(voucher, { 'productid': productId })
      this.purchaseFn(this.selectedVoucher, this.categoryIndex, productType)
    },
    purchaseAmountInfoList (voucher) {
      return get(voucher, 'purchase_amount_info_list', [])
    },
    getAmountDataValue (amountData, key) {
      return get(amountData, key)
    },
    isDiscount (amountData) {
      return this.getAmountDataValue(amountData, 'discount_rate') !== ''
    },
    isMonthAmount (amountData) {
      return defaultTo(this.getAmountDataValue(amountData, 'month_amount'), '') !== ''
    },
    isRecommendation (voucher) {
      return this.getValue(voucher, 'recommendation')
    },
    isInUse (voucher) {
      return this.getValue(voucher, 'in_use')
    }
  }
}
</script>
<style scoped>
  .voucher-list{
    padding-bottom: 12px;
  }
</style>
